import { Box } from '@mui/material';
import React from 'react';
import { styles } from './styles';

export default function CommonJSVertSlider({ slides, marginTops }) {
  const height = slides.length === 6 ? 290 : 170;
  marginTops = marginTops.reduce(
    (acc, item, index) => [...acc, index === 0 ? (170 - height) / 8 : item],
    ['-50px'],
  );

  return (
    <Box sx={styles.wrapper}>
      {slides && (
        <>
          {slides.map((Slide, index) => (
            <Box key={index} sx={styles.slide(marginTops, index, height)}>
              <Slide />
            </Box>
          ))}
        </>
      )}
    </Box>
  );
}
